import { request } from "@/lib/api";

function authorizationPath(id) {
  return `/api/me/mcp-authorizations/${encodeURIComponent(id)}`;
}

export function getMcpAuthorization(id) {
  return request(authorizationPath(id), { forceFresh: true });
}

export function approveMcpAuthorization(id, accountIds, permissions = {}) {
  return request(`${authorizationPath(id)}/approve`, {
    method: "POST", body: JSON.stringify({ account_ids: accountIds, ...permissions }),
  });
}

export function denyMcpAuthorization(id) {
  return request(`${authorizationPath(id)}/deny`, { method: "POST" });
}

export function getMcpUpstreamAuthorization(id) {
  return request(`/api/me/mcp-upstream-authorizations/${encodeURIComponent(id)}`, { forceFresh: true });
}

export function decideMcpUpstreamAuthorization(id, approved) {
  return request(`/api/me/mcp-upstream-authorizations/${encodeURIComponent(id)}/${approved ? "approve" : "deny"}`, { method: "POST" });
}

export function listMcpConnections() {
  return request("/api/me/mcp-connections", { forceFresh: true });
}

export function revokeMcpConnection(id) {
  return request(`/api/me/mcp-connections/${encodeURIComponent(id)}`, { method: "DELETE" });
}
